import { PaymentStatus, PaymentMethod } from '../state/types/payments';

export const it = {
  payments: {
    pageTitle: 'Piattaforma » Pagamenti',
    generalFeedback: {
      success: 'Pagamento eseguito con successo',
      error: 'Si è verificato un problema, ti preghiamo di riprovare.',
      confirmFeedback: {
        logged: 'Torna alla Home',
        notLogged: 'Vai alla Login',
      },
    },
    pay: 'Paga',
    recharge: 'Ricarica',
    table: {
      tableTitle: 'Cronologia Pagamenti',
      name: 'Nome pagamento',
      executionDate: 'Data di esecuzione',
      transactionAmount: 'Importo del pagamento',
      status: {
        label: 'Stato del pagamento',
        [PaymentStatus.PAID]: 'Pagato',
        [PaymentStatus.PARTIALLY_PAID]: 'Parzialmente pagato',
        [PaymentStatus.REFUNDED]: 'Rimborsato',
        [PaymentStatus.CANCELED]: 'Annullato',
        [PaymentStatus.UNKNOWN]: 'Sconosciuto',
        [PaymentStatus.PENDING]: 'Da pagare',
        [PaymentStatus.FAILED]: 'Fallito',
      },
    },
    filter: {
      title: 'Filtri',
      dateRange: 'Periodo',
      fromDate: 'Da',
      toDate: 'A',
      amountRange: 'Importo',
      fromAmount: 'Da',
      toAmount: 'A',
      statusPlaceholder: {
        label: 'Stato del pagamento',
        placeholder: 'Seleziona uno stato',
        [PaymentStatus.PAID]: 'Pagato',
        [PaymentStatus.PARTIALLY_PAID]: 'Parzialmente pagato',
        [PaymentStatus.REFUNDED]: 'Rimborsato',
        [PaymentStatus.CANCELED]: 'Annullato',
        [PaymentStatus.UNKNOWN]: 'Sconosciuto',
        [PaymentStatus.PENDING]: 'Da pagare',
        [PaymentStatus.FAILED]: 'Fallito',
      },
      close: 'Chiudi',
      filter: 'Filtra',
      reset: 'Elimina filtri',
    },
    noPaymentsFound: {
      title: 'Cronologia Pagamenti',
      description: 'Non sono ancora stati effettuati pagamenti',
    },
    detail: {
      title: 'Dettagli del pagamento',
      paymentId: 'ID Pagamento',
      paymentStatus: {
        label: 'Stato del pagamento',
        [PaymentStatus.PAID]: 'Pagato',
        [PaymentStatus.PARTIALLY_PAID]: 'Parzialmente pagato',
        [PaymentStatus.REFUNDED]: 'Rimborsato',
        [PaymentStatus.CANCELED]: 'Annullato',
        [PaymentStatus.UNKNOWN]: 'Sconosciuto',
        [PaymentStatus.PENDING]: 'Da pagare',
        [PaymentStatus.FAILED]: 'Fallito',
      },
      paymentDate: 'Data di esecuzione',
      paymentMethod: {
        label: 'Tipo di pagamento',
        [PaymentMethod.BANK_TRANSFER]: 'Bonifico bancario',
        [PaymentMethod.CREDIT_CARD]: 'Carta di credito',
      },
      transactionName: 'Nome della transazione',
      transactionAmount: 'Importo',
      organizationName: "Nome dell'organizzazione",
      productName: 'Nome del prodotto',
      bankInfo: {
        iban: 'IBAN',
        bic: 'BIC',
        accountHolderName: 'Intestatario del conto',
        country: 'Paese',
      },
      copyToClipboard: 'Copia negli appunti',
      copiedToClipboard: 'Copiato negli appunti',
    },
    pendingPaymentsList: {
      title: 'Rate da pagare',
      showDetails: 'Mostra dettagli',
    },
  },
};
